export default "__VITE_ASSET__8003dbf7__"